var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_930_1168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9975 33.5C12.6658 33.5 12.3475 33.3931 12.0758 33.1915C11.0837 32.4523 10.9502 31.6299 11.0131 31.0697C11.1866 29.5289 13.1052 27.9163 16.7175 26.2733C18.151 23.154 19.5149 19.3107 20.3279 16.0996C19.3767 14.044 18.4522 11.377 19.126 9.81265C19.3624 9.26469 19.6569 8.84449 20.2069 8.66278C20.523 8.57494 20.8476 8.52038 21.1752 8.5C21.6556 8.5 22.0778 9.11421 22.3771 9.49277C22.6583 9.84861 23.2959 10.6029 22.0216 15.9302C23.3064 18.5649 25.1269 21.2489 26.8711 23.0868C28.1206 22.8625 29.1957 22.748 30.0716 22.748C31.5642 22.748 32.4687 23.0934 32.8376 23.8051C33.1426 24.3938 33.0177 25.0818 32.4659 25.8493C31.935 26.5866 31.203 26.9765 30.3499 26.9765C29.1909 26.9765 27.8413 26.2497 26.3364 24.814C23.6324 25.3752 20.4747 26.3765 17.9223 27.4847C17.1255 29.1636 16.362 30.516 15.651 31.5078C14.674 32.8659 13.8315 33.5 12.9975 33.5ZM15.5347 28.6488C13.4979 29.7854 12.6677 30.7195 12.6077 31.2457C12.5982 31.3328 12.5724 31.5618 13.0185 31.9006C13.1605 31.8561 13.9897 31.4804 15.5347 28.6488ZM28.5323 24.4449C29.3091 25.0383 29.4988 25.3383 30.0068 25.3383C30.2298 25.3383 30.8656 25.3288 31.1601 24.9209C31.3021 24.7231 31.3574 24.5963 31.3793 24.5282C31.2621 24.4667 31.1067 24.3417 30.2594 24.3417C29.7781 24.3427 29.1728 24.3635 28.5323 24.4449ZM21.4126 18.2157C20.699 20.6475 19.8481 23.0375 18.8639 25.3742C20.8816 24.5981 22.9502 23.9594 25.0554 23.4625C23.7687 21.9786 22.4829 20.1255 21.4126 18.2157ZM20.834 10.2073C20.7406 10.2385 19.5664 11.8701 20.9255 13.2509C21.83 11.2493 20.875 10.194 20.834 10.2073Z",
    fill: "#FF2116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_930_1168",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_930_1168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_930_1168",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfEx);
export default __webpack_public_path__ + "static/media/pdf-ex.8066e317e55b153afbb8507657b59cc5.svg";
export { ForwardRef as ReactComponent };